@if (show) {
<ngx-skeleton-loader
  count="1"
  appearance="line"
  [theme]="{
        height: '1.8rem',
        margin: '0',
        borderRadius: '0',
      }"
/>
}
